// import React, { useState, useEffect } from 'react';
// import {
//   TextField,
//   Button,
//   Paper,
//   Typography,
//   Box,
//   Snackbar,
//   Alert,
//   IconButton,
//   FormControl,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { AddCircleOutline, Delete } from '@mui/icons-material';
// import { addProducts, getAllCategoryGroups } from '../../../../services/menuPage';

// const AddProductsForm = ({ onSuccess }) => {
//   const [products, setProducts] = useState([
//     { name: '', price: '', description: '', category_id: '', image: null, product_cost: '', is_preparing: '0', preparing_time: '' }
//   ]);
//   const [categories, setCategories] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const loadCategories = async () => {
//       try {
//         const data = await getAllCategoryGroups();
//         setCategories(data);
//       } catch (error) {
//         console.error("❌ فشل في جلب المجموعات:", error.message);
//       }
//     };

//     loadCategories();
//   }, []);

//   const handleChange = (index, e) => {
//     const { name, value, files, type, checked } = e.target;
//     const newProducts = [...products];
//     let val;
//     if (type === 'file') val = files ? files[0] : null;
//     else if (type === 'checkbox') val = checked ? '1' : '0';
//     else val = value;
//     newProducts[index][name] = val;
//     setProducts(newProducts);
//   };

//   const handleAddProduct = () => {
//     setProducts([...products, { name: '', price: '', description: '', category_id: '', image: null, product_cost: '', is_preparing: '0', preparing_time: '' }]);
//   };

//   const handleRemoveProduct = (index) => {
//     const newProducts = [...products];
//     newProducts.splice(index, 1);
//     setProducts(newProducts);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);

//     try {
//       // نرسل البيانات كـ FormData بحيث يتم إرسال الحقول كمصفوفات (e.g. product_cost[], is_preparing[], preparing_time[])
//       const formData = new FormData();
//       products.forEach((p, idx) => {
//         formData.append('name[]', p.name ?? '');
//         formData.append('price[]', p.price ?? '');
//         formData.append('description[]', p.description ?? '');
//         formData.append('category_id[]', p.category_id ?? '');
//         formData.append('product_cost[]', p.product_cost ?? '');
//         formData.append('is_preparing[]', p.is_preparing ?? '0');
//         formData.append('preparing_time[]', p.preparing_time ?? '');
//         if (p.image) {
//           // اسم الحقل قد يكون image[] أو product_image[] حسب الـ API — هنا استخدمنا image[]
//           formData.append('image[]', p.image);
//         } else {
//           // بعض الـ APIs تتوقع إدخال قيمة فارغة للصور المفقودة — يمكن تعديل حسب الحاجة
//           // formData.append('image[]', '');
          
//         }
        
//       });

// await addProducts(products);

//       setMessage({ type: 'success', text: '✅ تم إضافة المنتجات بنجاح' });
//       setProducts([{ name: '', price: '', description: '', category_id: '', image: null }]);

//       if (onSuccess) onSuccess();
//     } catch (error) {
//       console.error("🚫 خطأ أثناء إضافة المنتجات:", error.message);
//       setMessage({ type: 'error', text: error.message });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseSnackbar = () => setMessage(null);

//   return (
//     <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
//       <Typography variant="h6" gutterBottom>إضافة منتجات جديدة</Typography>
//       <form onSubmit={handleSubmit} encType="multipart/form-data">
//         {products.map((product, index) => (
//           <Box key={index} sx={{ border: '1px solid #ddd', p: 2, mb: 2, borderRadius: 2 }}>
//             <TextField
//               label="اسم المنتج"
//               name="name"
//               value={product.name}
//               onChange={(e) => handleChange(index, e)}
//               fullWidth
//               margin="normal"
//             />

//             <TextField
//               label="السعر"
//               name="price"
//               value={product.price}
//               onChange={(e) => handleChange(index, e)}
//               fullWidth
//               margin="normal"
//             />

//             <TextField
//               label="تكلفة المنتج"
//               name="product_cost"
//               value={product.product_cost}
//               onChange={(e) => handleChange(index, e)}
//               fullWidth
//               margin="normal"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   name="is_preparing"
//                   checked={product.is_preparing === '1'}
//                   onChange={(e) => handleChange(index, e)}
//                 />
//               }
//               label="يُحضَّر (يحتاج تحضير)"
//             />

//             <TextField
//               label="زمن التحضير (دقائق)"
//               name="preparing_time"
//               type="number"
//               value={product.preparing_time}
//               onChange={(e) => handleChange(index, e)}
//               fullWidth
//               margin="normal"
//               inputProps={{ min: 0 }}
//             />

//             <TextField
//               label="الوصف"
//               name="description"
//               value={product.description}
//               onChange={(e) => handleChange(index, e)}
//               fullWidth
//               margin="normal"
//             />

//             <FormControl fullWidth margin="normal">
//               <Typography variant="subtitle2">المجموعة</Typography>
//               <Select
//                 name="category_id"
//                 value={product.category_id}
//                 onChange={(e) => handleChange(index, e)}
//               >
//                 {categories.map((category) => (
//                   <MenuItem key={category.id} value={category.id}>
//                     {category.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <Box mt={1}>
//               <input
//                 type="file"
//                 name="image"
//                 accept="image/*"
//                 onChange={(e) => handleChange(index, e)}
//               />
//             </Box>

//             <IconButton color="error" onClick={() => handleRemoveProduct(index)} sx={{ mt: 1 }}>
//               <Delete />
//             </IconButton>
//           </Box>
//         ))}

//         <Button
//           variant="outlined"
//           startIcon={<AddCircleOutline />}
//           onClick={handleAddProduct}
//           sx={{ mb: 2 }}
//         >
//           إضافة منتج آخر
//         </Button>

//         <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
//           {loading ? 'جارٍ الإرسال...' : 'حفظ المنتجات'}
//         </Button>
//       </form>

//       {message && (
//         <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
//           <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
//             {message.text}
//           </Alert>
//         </Snackbar>
//       )}
//     </Paper>
//   );
// };

// export default AddProductsForm;

// src/pages/Dashboard/MenuPage/AddProductsForm.js
// src/pages/Dashboard/MenuPage/AddProductsForm.js
import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Box,
  Snackbar,
  Alert,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { AddCircleOutline, Delete } from '@mui/icons-material';
import { addProducts, getAllCategoryGroups } from '../../../../services/menuPage';
import { useFeatures } from '../../../../context/PermissionsAndFeatures/FeaturesContext'; // ✅ استدعاء مزود الخصائص

const AddProductsForm = ({ onSuccess }) => {
  const { hasFeature } = useFeatures();
  const allowImageUpload = hasFeature('product_image_description'); // ✅ الميزة المطلوبة

  const [products, setProducts] = useState([
    { name: '', price: '', description: '', category_id: '', image: null, product_cost: '', is_preparing: '0', preparing_time: '' }
  ]);
  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await getAllCategoryGroups();
        setCategories(data);
      } catch (error) {
        console.error("❌ فشل في جلب المجموعات:", error.message);
      }
    };

    loadCategories();
  }, []);

  const handleChange = (index, e) => {
    const { name, value, files, type, checked } = e.target;
    const newProducts = [...products];
    let val;
    if (type === 'file') val = files ? files[0] : null;
    else if (type === 'checkbox') val = checked ? '1' : '0';
    else val = value;
    newProducts[index][name] = val;
    setProducts(newProducts);
  };

  const handleAddProduct = () => {
    setProducts([...products, { name: '', price: '', description: '', category_id: '', image: null, product_cost: '', is_preparing: '0', preparing_time: '' }]);
  };

  const handleRemoveProduct = (index) => {
    const newProducts = [...products];
    newProducts.splice(index, 1);
    setProducts(newProducts);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const formData = new FormData();
      products.forEach((p) => {
        formData.append('name[]', p.name ?? '');
        formData.append('price[]', p.price ?? '');
        formData.append('description[]', p.description ?? '');
        formData.append('category_id[]', p.category_id ?? '');
        formData.append('product_cost[]', p.product_cost ?? '');
        formData.append('is_preparing[]', p.is_preparing ?? '0');
        formData.append('preparing_time[]', p.preparing_time ?? '');
        
        // ✅ رفع الصورة فقط إذا كانت الميزة مفعلة
        if (allowImageUpload && p.image) {
          formData.append('image[]', p.image);
        }
      });

      await addProducts(products);

      setMessage({ type: 'success', text: '✅ تم إضافة المنتجات بنجاح' });
      setProducts([{ name: '', price: '', description: '', category_id: '', image: null }]);

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("🚫 خطأ أثناء إضافة المنتجات:", error.message);
      setMessage({ type: 'error', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>إضافة منتجات جديدة</Typography>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        {products.map((product, index) => (
          <Box key={index} sx={{ border: '1px solid #ddd', p: 2, mb: 2, borderRadius: 2 }}>
            <TextField
              label="اسم المنتج"
              name="name"
              value={product.name}
              onChange={(e) => handleChange(index, e)}
              fullWidth
              margin="normal"
            />

            <TextField
              label="السعر"
              name="price"
              value={product.price}
              onChange={(e) => handleChange(index, e)}
              fullWidth
              margin="normal"
            />

            <TextField
              label="تكلفة المنتج"
              name="product_cost"
              value={product.product_cost}
              onChange={(e) => handleChange(index, e)}
              fullWidth
              margin="normal"
            />

            <FormControlLabel
              control={
                <Checkbox
                  name="is_preparing"
                  checked={product.is_preparing === '1'}
                  onChange={(e) => handleChange(index, e)}
                />
              }
              label="يُحضَّر (يحتاج تحضير)"
            />

            <TextField
              label="زمن التحضير (دقائق)"
              name="preparing_time"
              type="number"
              value={product.preparing_time}
              onChange={(e) => handleChange(index, e)}
              fullWidth
              margin="normal"
              inputProps={{ min: 0 }}
            />

            <TextField
              label="الوصف"
              name="description"
              value={product.description}
              onChange={(e) => handleChange(index, e)}
              fullWidth
              margin="normal"
            />

            <FormControl fullWidth margin="normal">
              <Typography variant="subtitle2">المجموعة</Typography>
              <Select
                name="category_id"
                value={product.category_id}
                onChange={(e) => handleChange(index, e)}
              >
                {categories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* ✅ رفع الصورة فقط إذا كانت الميزة مفعّلة */}
            {allowImageUpload ? (
              <Box mt={1}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>صورة المنتج</Typography>
                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={(e) => handleChange(index, e)}
                />
              </Box>
            ) : (
              <Alert severity="info" sx={{ mt: 2 }}>
                ⚙️ ميزة رفع الصور غير مفعّلة في حسابك. يمكنك تفعيلها من إعدادات الخطة أو التواصل مع الدعم.
              </Alert>
            )}

            <IconButton color="error" onClick={() => handleRemoveProduct(index)} sx={{ mt: 1 }}>
              <Delete />
            </IconButton>
          </Box>
        ))}

        <Button
          variant="outlined"
          startIcon={<AddCircleOutline />}
          onClick={handleAddProduct}
          sx={{ mb: 2 }}
        >
          إضافة منتج آخر
        </Button>

        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
          {loading ? 'جارٍ الإرسال...' : 'حفظ المنتجات'}
        </Button>
      </form>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default AddProductsForm;
